class PoiOpeningHours {

  constructor (dayRangeJson, timeZone) {
    this.timeZone = timeZone
    this.day = dayRangeJson.day_name
    this.name = dayRangeJson.localized_day_name || dayRangeJson.day_name
    // this.localizedDayName = dayRangeJson.localized_day_name
    this.times = dayRangeJson.times
  }

  // getLocalizedDayName () {
  //   return this.localizedDayName
  // }

  /**
   *
   * Returns the opening times in the time zone requestable via getTimeZone()
   * @returns {Array<{open_time: string, close_time: string}>}
   */
  getTimes () {
    return this.times
  }

  /**
   * @returns {string}
   */
  getTimeZone () {
    return this.timeZone
  }

}

export default PoiOpeningHours



// WEBPACK FOOTER //
// ./src/data/PoiOpeningHours.js